import getCookie from './getCookie';

/**
 * Must match the experiment key in GrowthBook and `DEAL_LABEL_EXPERIMENT` in
 * `services/frontend/hooks/useDealLabel.js`.
 */
export const DEAL_LABEL_EXPERIMENT = 'deal-label';

/**
 * Whether the visitor is in the treatment of the `deal-label` GrowthBook
 * experiment, which shows a translated "DEAL" on discount labels instead of
 * the percentage.
 *
 * Reads the `gb` cookie the CloudFront edge writes (`key:index` entries joined
 * by `|`). A missing cookie, no consent or any other variation is the control.
 * Exposure is reported by the Next.js frontend, not here.
 *
 * @returns {boolean}
 */
export default function isDealLabelEnabled() {
  if (typeof document === 'undefined') {
    return false;
  }

  const gb = getCookie('gb');
  return Boolean(gb) && gb.split('|').includes(`${DEAL_LABEL_EXPERIMENT}:1`);
}
